import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import {hover, regular, white, whites} from "../../styles/globalStyleVars";
import CloseButton from "../CloseButton";
import SimpleBar from "simplebar-react";
import TeamSingle from "./TeamSingle";
import ReactHtmlParser from "react-html-parser";
import Title from "../Title";




const MyComponent = ({data,management,id}) => {

    let datades=`<p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
</p>
<p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>
`
    const [title, setTitle] = useState();
    const [img, setImg] = useState();
    const [deg, setDeg] = useState();
    const [desc, setDesc] = useState();


    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    const handlePopup = (content) => {
        const {title, img, deg, description} = content;
        setTitle(title);
        setImg(img);
        setDeg(deg);
        setDesc(description);
        setShow(true);
    };

    const [modalOpen, setModalOpen] = useState(false); // Added state for modal


    // modal
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setModalOpen(false); // Set modal state to closed when modal is closed
        document.documentElement.classList.remove('modal-open'); // Remove class
    };

    const handleShow = () => {
        setShow(true);
        setModalOpen(true); // Set modal state to open when modal is shown
        document.documentElement.classList.add('modal-open'); // Add class
    };


    useEffect(() => {
        if (modalOpen) {
            document.documentElement.style.overflowY = 'hidden';
        } else {
            document.documentElement.style.overflowY = 'scroll';
        }

        return () => {
            // Cleanup: reset the style when the component unmounts
            document.documentElement.style.overflowY = 'scroll';
        };
    }, [modalOpen]);

    return (
        <StyledComponent className={`management-team ${management ? '' : ''}` } id={`${id ? id : ''}`}>
            <Container>
                <Row>
                    <Col md={12}>
                        <Title margin={'0 0 60px 0'} marginMobile={'0 0 40px 0'}
                               text={data?.title} fontWeight={`${regular}`}/>
                    </Col>
                    {
                        data?.list && data?.list?.length>0 &&
                        data?.list?.map((element,index)=>{
                            return(
                                <Col md={3} sm={4} onClick={handleShow} key={index}>
                                    <TeamSingle handlePopup={handlePopup}
                                                title={element?.name}
                                                deg={element?.designation}
                                                img={element?.image}
                                                description={element?.description}/>
                                </Col>
                            )
                        })
                    }

                    {/*<Col md={3} sm={4} onClick={handleShow}>*/}
                    {/*    <TeamSingle handlePopup={handlePopup} title={'Alexander Stonefield'}*/}
                    {/*                deg={'Vice Chairman'}*/}
                    {/*                img={'/images/dynamic/about/bod-2.jpg'}*/}
                    {/*                description={datades}/>*/}
                    {/*</Col>*/}
                    {/*<Col md={3} sm={4} onClick={handleShow}>*/}
                    {/*    <TeamSingle handlePopup={handlePopup} title={'Sophia Davenport'}*/}
                    {/*                deg={'Managing Director'}*/}
                    {/*                img={'/images/dynamic/about/bod-3.jpg'}*/}
                    {/*                description={datades}/>*/}
                    {/*</Col>*/}
                    {/*<Col md={3} sm={4} onClick={handleShow}>*/}
                    {/*    <TeamSingle handlePopup={handlePopup} title={'Liam Forger'}*/}
                    {/*                deg={'Deputy Managing Director'}*/}
                    {/*                img={'/images/dynamic/about/bod-4.jpg'}*/}
                    {/*                description={datades}/>*/}
                    {/*</Col>*/}
                    {/*<Col md={3} sm={4} onClick={handleShow}>*/}
                    {/*    <TeamSingle handlePopup={handlePopup} title={'Liam Whitman'}*/}
                    {/*                deg={'CEO'}*/}
                    {/*                img={'/images/dynamic/about/bod-5.jpg'}*/}
                    {/*                description={datades}/>*/}
                    {/*</Col>*/}
                    {/*<Col md={3} sm={4} onClick={handleShow}>*/}
                    {/*    <TeamSingle handlePopup={handlePopup} title={'Victoria Hawthorne'}*/}
                    {/*                deg={'Director'}*/}
                    {/*                img={'/images/dynamic/about/bod-6.jpg'}*/}
                    {/*                description={datades}/>*/}
                    {/*</Col>*/}

                </Row>
            </Container>

            <Modal className={'team-modal'} show={show} onHide={handleClose}>
                <div onClick={handleClose}>
                    <CloseButton/>
                </div>
                <SimpleBar style={{maxHeight: window.innerHeight - 150 + 'px'}}>
                    <div className="team-modal__content">
                        <img src={img} alt=""/>
                        <div className="team-modal__content__header">
                            <p>{title}</p>
                            <p>{deg}</p>
                        </div>
                        <div className="team-modal__content__body">
                            {ReactHtmlParser(desc)}
                        </div>
                    </div>
                </SimpleBar>
            </Modal>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  background-color: #F8F8F8;
  padding-bottom: 140px;
  
  @media(max-width: 767px){
    padding-bottom: 0px;
  }

  .team-single {
    margin-bottom: 60px;

    &__content {
      border-color: rgba(245, 245, 245, 0.5);

      h4 {
        color: ${white};
      }

      p {
        color: rgba(245, 245, 245, 0.5);
      }
    }

    @media (max-width: 600px) {
      margin-bottom: 40px;
    }
  }
`;

export default MyComponent;
